var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2BA8E8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 6h.337c.244 0 .367 0 .482.028.103.025.2.065.29.12.1.061.187.148.36.32l3.063 3.063c.172.173.258.26.32.36.055.09.095.187.12.29.028.114.028.235.028.474V18M9 6H4.6c-.56 0-.84 0-1.054.109a1 1 0 00-.437.437C3 6.76 3 7.04 3 7.6v11.8c0 .56 0 .84.109 1.054a1 1 0 00.437.437C3.76 21 4.039 21 4.598 21h7.803c.559 0 .84 0 1.053-.109a1 1 0 00.437-.437C14 20.24 14 19.96 14 19.4V18M9 6v3.4c0 .56 0 .84.109 1.054a1 1 0 00.437.437c.214.109.493.109 1.052.109H14m0 7h5.402c.558 0 .838 0 1.053-.109a1 1 0 00.435-.437c.11-.214.11-.494.11-1.054V7.655c0-.239 0-.36-.028-.474a1.005 1.005 0 00-.12-.29c-.062-.1-.148-.187-.32-.36l-3.063-3.063c-.173-.172-.26-.259-.36-.32a1.004 1.004 0 00-.29-.12C16.704 3 16.581 3 16.337 3H16m-6 3V4.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C10.76 3 11.04 3 11.6 3H16m0 0v3.4c0 .56 0 .84.109 1.054a1 1 0 00.437.437C16.76 8 17.039 8 17.598 8H21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyFile);
export default ForwardRef;